import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import Tag from "backpack-ui/dist/components/tag";
import TagList from "backpack-ui/dist/components/tagList";

const TypeSelector = ({ listType = "", menuItems = [], onClick = null }) => (
  <TagList
    limit={10}
    style={{
      height: "36px",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }}
  >
    {menuItems.map(({ slug, title, type }) => (
      <Tag
        href="#"
        selected={type === listType}
        key={title}
        onClick={() => {
          if (onClick) {
            onClick();
          }

          browserHistory.push(slug);
        }}
      >
        {title}
      </Tag>
    ))}
  </TagList>
);

TypeSelector.propTypes = {
  /**
   * listType for Type Selector
   */
  listType: PropTypes.string.isRequired,

  /**
   * Menu Items for Type Selector
   */
  menuItems: PropTypes.array.isRequired,

  /**
   * Method to run when the Link component is clicked
   */
  onClick: PropTypes.func,
};

export default TypeSelector;



// WEBPACK FOOTER //
// ./assets/list/components/typeSelector/index.jsx